import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../AuthContext';
import apiClient from '../../api/apiClient';

const AdminDashboard = () => {
  const [products, setProducts] = useState([]);
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const fetchProducts = async () => {
    try {
      const res = await apiClient.get('/admin/aff/all');
      setProducts(res.data);
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure to delete?')) {
      try {
        await apiClient.delete(`/admin/aff/${id}`);
        fetchProducts();
      } catch (err) {
        console.error('Error deleting product:', err);
      }
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/admin-login');
    } else {
      fetchProducts();
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="container mt-5">
      <h2>Admin Panel – Product List</h2>
      <Link to="/admin-login/aff/add-aff" className="btn btn-success mb-3">
        Add Product
      </Link>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Title</th>
              <th>Affiliate Link</th>
              <th>Original Price</th>
              <th>Price</th>
              <th>Platform</th>
              <th>Category</th>
              <th>Brand</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.map((prod) => (
                <tr
  key={prod.id}
  style={{
    backgroundColor: prod.active ? '#93d8b4ff' : '#d75454',
    color: 'white',
    '--bs-table-bg': prod.active ? '#c9d1cdff' : '#cab5b5ff', // override Bootstrap var
  }}
>

                <td>{prod.title}</td>
                <td>{prod.affiliateLink}</td>
                 <td>₹{prod.originalPrice}</td>
                <td>₹{prod.price}</td>
                <td>{prod.platform}</td>
                <td>{prod.category}</td>
                <td>{prod.brand}</td>
                
                <td>
                  <Link
                    to={`/admin-login/aff/update/${prod.id}`}
                    className="btn btn-primary btn-sm me-2"
                  >
                    Update
                  </Link>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(prod.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {products.length === 0 && (
              <tr>
                <td colSpan="6">No products found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
